import React from "react";

import { Provider } from "../contexts/localization";

type WithLocalizationContextProviderProps = {
    localization: LocalizationConfig;
};

export const withLocalizationContextProvider =
    <P extends WithLocalizationContextProviderProps>(
        Component: React.ComponentType<P>,
    ) =>
    (props: P) => {
        const { localization } = props;

        return (
            <Provider value={localization}>
                <Component {...props} />
            </Provider>
        );
    };
